import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import DontLeave from "app/pages/.shared/DontLeave";
import Page from "app/pages/.shared/Page/Page";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { sendTagOnPageNotFound } from "app/utils/analytics";
import { getFallbackRedirectUrl, getSeoMetaData } from "app/reducers/partnerSelector";
import { useSelector, shallowEqual } from "react-redux";
import "./NotFound.scss";
import { ButtonLink } from "app/components/ui/ButtonLink/ButtonLink";

const mapStateToProps = state => {
	return {
		fallbackRedirectUrl: getFallbackRedirectUrl(state),
		titleFromSanity: getSeoMetaData("notFound.metaTitle")(state),
		descriptionFromSanity: getSeoMetaData("notFound.metaDescription")(state),
	};
};

const NotFound = () => {
	const { fallbackRedirectUrl, titleFromSanity, descriptionFromSanity } = useSelector(
		mapStateToProps,
		shallowEqual
	);

	useEffect(() => {
		sendTagOnPageNotFound();
	}, []);

	const title = titleFromSanity || "page.title.404";
	const description = descriptionFromSanity || "page.description.404";

	return (
		<div className="not-found">
			<Page title={<FormattedMessage id="not.found.title" />}>
				<HeadMetadata description={description} title={title} />
				<div className="not-found__intro">
					<FormattedMessage id="not.found.message" />
					<DontLeave>
						<ButtonLink
							variant="primary"
							size="lg"
							to={{ pathname: fallbackRedirectUrl }}
							data-testid="confirm-leave-link"
						>
							<FormattedMessage id="confirmation.leave.button.label" />
						</ButtonLink>
					</DontLeave>
				</div>
			</Page>
		</div>
	);
};

export default NotFound;
